export class Shared {
  public static WHATSAPP = 'https://api.whatsapp.com/send?text=';
  public static FACEBOOK = 'https://facebook.com/sharer.php?u=';
  //public static TWITTER = 'https://twitter.com/intent/tweet?text=';
  public static TWITTER = 'https://x.com/intent/post?text=';
  public static SMS = 'sms:?&body=';
  public static MAPS = 'https://maps.google.com/?q=';
  public static PHONE = 'tel:+';
}
